import { getSizeStyles, sizeToPxValue } from './avatarSizes';
export var avatarStyles = {
  root: function root(_ref) {
    var size = _ref.props.size,
        initialsFontWeight = _ref.variables.initialsFontWeight;
    return Object.assign({
      position: 'relative',
      backgroundColor: 'inherit',
      display: 'inline-block',
      verticalAlign: 'middle',
      fontWeight: initialsFontWeight
    }, getSizeStyles(sizeToPxValue[size]));
  }
};